import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import { breakpoints } from "plos/src/styles/breakpoints";

export const headerContainerStyles = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  gap: vars.space.m,
  marginBottom: vars.space.m,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
  },
});

export const explainerContainerStyles = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  marginTop: vars.space.xs,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      marginInlineEnd: "30%",
    },
  },
});

export const displayMessageStyles = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.s,
  marginTop: vars.space.xs,
});

export const tableWrapperStyles = style({
  overflowX: "auto",
});
